<template>
  <div>
    <div class="product-code-item" @click="goto">
      <settings-bar
        :selected="isSelected"
        :fade="!product.active"
        :title="productTitle"
        :materialId="materialId"
      >
        <template #icon-slot>
          <div
            :key="`status-${productStatus}`"
            v-tooltip="getStatusTooltip(productStatus)"
            :class="['material-status', getStatusClass(productStatus)]"
          ></div>
        </template>
      </settings-bar>
    </div>
    <div v-if="product.open" class="pl-2">
      <div v-if="product.loading" class="p-3 center s">
        <loading-circle />
      </div>
      <div
        v-if="!product.loading && productObject.childrens.length === 0"
        class="product-code-item center"
      >
        <div class="product-code-item__name v-center s elipsis-text">
          No child product code
        </div>
      </div>
      <template v-else>
        <product-code-item
          v-for="childProductCode in productObject.childrens"
          :key="childProductCode.cid"
          :product-object="childProductCode"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SettingsBar from '../../common/settingsBar.vue'
import LoadingCircle from '../../common/loadingCircle.vue'
import ProductCodeItem from './productCodeItem.vue'
import config from '@/config'
export default {
  name: 'ProductCodeItem',
  components: {
    SettingsBar,
    ProductCodeItem,
    LoadingCircle
  },
  props: {
    productObject: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('productBom', ['productCodeTree', 'selectedProductCode']),
    product () {
      return this.productCodeTree.items[this.productObject.cid]
    },
    isSelected () {
      return this.selectedProductCode === this.product.product_code
    },
    productStatus () {
      return this.product.status || (this.product.active ? 1 : 2)
    },
    productTitle () {
      return `${this.product.product_code_name}${this.product.associatedBomId ? ` (${this.product.associatedBomName})` : ''}`
    },
    materialId () {
      return this.product?.material_id
    }
  },
  methods: {
    goto () {
      this.$store.dispatch('productBom/gotoProduct', this.productObject.cid)
    },
    expand () {
      this.$store.dispatch('productBom/expandProduct', this.productObject.cid)
    },
    getStatusClass (status) {
      switch (status) {
      case config.MATERIAL_STATUS_INVERTED_MAP.ACTIVE:
        return 'status-active'
      case config.MATERIAL_STATUS_INVERTED_MAP.OBSELETE:
        return 'status-obsolete'
      // case config.MATERIAL_STATUS_INVERTED_MAP.HOLD:
      //   return 'status-hold'
      case config.MATERIAL_STATUS_INVERTED_MAP.LOCKED:
        return 'status-locked'
      case config.MATERIAL_STATUS_INVERTED_MAP.RELEASED:
        return 'status-released'
      default:
        return ''
      }
    },
    getStatusTooltip (status) {
      switch (status) {
      case config.MATERIAL_STATUS_INVERTED_MAP.ACTIVE:
        return 'Active'
      case config.MATERIAL_STATUS_INVERTED_MAP.OBSELETE:
        return 'Obsolete'
      // case config.MATERIAL_STATUS_INVERTED_MAP.HOLD:
      //   return 'Hold'
      case config.MATERIAL_STATUS_INVERTED_MAP.LOCKED:
        return 'Locked'
      case config.MATERIAL_STATUS_INVERTED_MAP.RELEASED:
        return 'Released'
      default:
        return 'Unknown status'
      }
    }
  }
}
</script>

<style lang="scss" scoped >
$status-colors: (
  active: #16A34A,
  released: #2563EB,
  obsolete: #6B7280,
  locked: #DC2626
);

.material-status {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);

  @each $name, $color in $status-colors {
    &.status-#{$name} {
      background-color: $color;
    }
  }
}

.product-code-item {
  margin: 1px 0px;
  cursor: pointer;

  ::v-deep(.card-content) {
    padding: 8px 10px;
  }

  ::v-deep(.title) {
    min-width: 0;
  }

  ::v-deep(.text-section) {
    min-width: 0;
    flex: 1;
  }
}

.toggle-button {
  height: 24px;
  width: 24px;
  background-color: var(--brand-color);
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.5;

  &.active {
    opacity: 1;
    cursor: pointer;
    pointer-events: all;
  }

  &.rotate {
    img {
      transform: rotate(0deg);
    }
  }

  & img {
    height: 16px;
    width: 16px;
    transform: rotate(-90deg);
  }
}
</style>
